import { FileChartLineIcon, FileChartPieIcon, FileSliders, MessageSquareReply, ScatterChart, UserCog } from "lucide-react"

export const ADMIN_PANEL_HEADER = {
    USER_MANAGER: {
      title: "User Manager",
      icon: UserCog,  
    },
    FEEDBACK_MANAGER: {
      title: "Feedback Manager",
      icon: MessageSquareReply,
    },
    CHAT_METRICS: {
      title: "Chat Metrics",
      icon: ScatterChart,
    },
    CORPUS_MANAGER: {
        title: "Corpus Manager",
        icon: FileSliders,  
    },
    OVERALL_RESPONSE_VALIDATOR: {
        title: "Overall Response Validator",
        icon: FileChartLineIcon,  
    },
    LIVE_RESPONSE_MONITOR: {
        title: "Live Response monitor",
        icon: FileChartPieIcon,  
      }
}